import worldCountries from 'world-countries'

export const countries = worldCountries
    .map((country) => ({
        code: country.cca2.toLowerCase(),
        name: country.name.common,
    }))
    .sort((a, b) => a.name.localeCompare(b.name))
